<template>
  <HeaderComponent/>
  <div class="page">
    <main class="workspace">
      <section class="chat-panel">
        <ChatWindow @dimensions="dimensions = $event"/>
      </section>
      <aside class="result-panel">
        <DetectedDimensions
            :dimensions="dimensions"
        />
      </aside>
    </main>

  </div>
</template>

<script>
import ChatWindow from "@/components/ChatWindow.vue";
import DetectedDimensions from "@/components/DetectedDimensions.vue";
import HeaderComponent from '@/components/HeaderComponent.vue';

export default {

  name: "HomeView",

  components: {
    ChatWindow,
    DetectedDimensions,
    HeaderComponent
  },
  data(){
    return{
        dimensions:[]
    }
  }

}
</script>

<style scoped>

.page{
  height:100%;
  background:#111315;
  color:white;
  display:flex;
  flex-direction:column;
}

.workspace{
  flex:1;
  display:grid;
  grid-template-columns:minmax(650px, 45%) 1fr;
  gap:32px;
  padding-bottom:40px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  align-items:start;
}

.chat-panel{
  display:flex;
  height:80vh;
  min-height:0;
}

.result-panel{
    display:flex;
    flex-direction:column;
    height:80vh;
    min-height:0;
    overflow:scroll;
    background:#1b1d20;
    border:1px solid #2b2e33;
    border-radius:20px;
    padding:4%;
    margin: 20px 24px;
}

.placeholder{
  color:#9ca3af;
}

.placeholder h2{
  color:white;
  margin-bottom:20px;
}

@media(max-width:1200px){

  .workspace{
    grid-template-columns:1fr;
    padding:0;
  }

  .result-panel{
    min-height:400px;
  }


  .chat-panel{
    display:flex;
    height:80vh;
    min-height:0;
  }

  .page{
    height:100%;
    width: 100%;
    background:#111315;
    color:white;
    display:flex;
    flex-direction:column;
  }

}

</style>